var map = {
	"./caret.svg": "1f4a",
	"./chevron.svg": "079d",
	"./close.svg": "8b1b",
	"./facebook.svg": "8485",
	"./hamburger.svg": "f5d5",
	"./instagram.svg": "bd6c",
	"./search.svg": "d103",
	"./twitter.svg": "acf9",
	"./youtube.svg": "11ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";